import React from 'react'
import { BText } from '@prague-digi/ui-components'
import { compose } from 'redux'
import { connect } from 'react-redux'

import alertEmail from '../../assets/alert-email.svg'
import messages from '../../i18n'
import tickDone from '../../assets/tickDone.svg'
import { CallUs, DocsInfo, Notification, Title, PageControlButtons } from '../../components'
import { clientActions } from '../../redux/'
import { intl, IntlInterface, wizard, WizardInterface } from '../../hoc'

interface MapDispatchToProps {
  finishBranch: typeof clientActions.finishBranch
}

type Props = WizardInterface & IntlInterface & MapDispatchToProps

export const OkBranch: React.FC<Props> = ({ finishBranch, translate, translateHTML }: Props) => {
  const onSubmit = () => finishBranch(onSubmit)

  return (
    <>
      <Notification ownIconImg={alertEmail} title={translate(messages.okBranch.notification)} />
      <Title center message={messages.okBranch.title} img={tickDone} />

      <BText center>{translateHTML(messages.okBranch.perex)}</BText>

      <DocsInfo idCard income otherId />

      <PageControlButtons onSubmit={onSubmit} submitMessage={messages.okBranch.button} />

      <CallUs />
    </>
  )
}

const mapDispatchToProps: MapDispatchToProps = {
  finishBranch: clientActions.finishBranch,
}

const enhance = compose<Props>(connect(null, mapDispatchToProps), intl, wizard)

export default enhance(OkBranch)
